import type { ChannelBindingSummary } from '@sbc/domain-models/gateway';
import { Link } from '@tanstack/react-router';

import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { TableCell } from '@/components/ui/table';

export function BindingStatusBadge({ enabled }: { enabled: boolean }) {
  return enabled ? (
    <Badge variant="secondary">Enabled</Badge>
  ) : (
    <Badge variant="outline">Disabled</Badge>
  );
}

// The strategy → edit cells shared by the bindings list and a connection's detail table.
// The bindings list prepends its own connection cell; the detail page renders these alone.
export function BindingRowCells({ binding }: { binding: ChannelBindingSummary }) {
  return (
    <>
      <TableCell className="space-x-1">
        <Badge variant="secondary">{binding.strategyKey}</Badge>
        {binding.surface && <Badge variant="outline">{binding.surface}</Badge>}
        {binding.externalScope && <Badge variant="outline">{binding.externalScope}</Badge>}
      </TableCell>
      <TableCell className="text-sm">{binding.agentName}</TableCell>
      <TableCell className="text-sm">v{binding.versionNumber}</TableCell>
      <TableCell>
        <BindingStatusBadge enabled={binding.enabled} />
      </TableCell>
      <TableCell className="text-right">
        <Button asChild variant="ghost" size="sm">
          <Link to="/gateway/bindings/$bindingId/edit" params={{ bindingId: binding.id }}>
            Edit
          </Link>
        </Button>
      </TableCell>
    </>
  );
}
